export interface UserDemographicOption {
  id: string;
  name: string;
  path: string[];
  description?: string;
  audience_size: number;
  type:
    | 'interests'
    | 'behaviors'
    | 'life_events'
    | 'industries'
    | 'income'
    | 'family_statuses'
    | 'user_device';
}

export const exampleFacebookInterest: UserDemographicOption = {
  id: '234423',
  name: 'Skiing',
  path: ['Sports', 'Outdoors', 'Skiing'],
  audience_size: 500_000,
  type: 'interests',
};

export const exampleFacebookBehavior: UserDemographicOption = {
  id: '34355',
  name: 'Frequent Travelers',
  path: ['Travel', 'Frequent Travelers'],
  description:
    'People whose activities on Facebook suggest they are frequent travelers',
  audience_size: 100_000,
  type: 'behaviors',
};

export const exampleFacebookDemographic: UserDemographicOption = {
  id: '4523423',
  name: 'Long-distance relationship',
  path: ['Long-distance relationship'],
  description: 'People who are in a long distance relationship',
  audience_size: 30_000,
  type: 'life_events',
};

export interface ExtraUserDemographicOption {
  id: string;
  name: string;
  path: string[] | null;
  audience_size: number;
  type: string | null;
}

export const exampleFacebookInterestExtra: ExtraUserDemographicOption = {
  id: '34242',
  name: 'Scuba Diving',
  path: null,
  audience_size: 45_000,
  type: null,
};

export interface CountryOption {
  key: string;
  name: string;
  type: 'country';
  country_code: string;
  supports_region: boolean;
  supports_city: boolean;
}

export const exampleCountryOption: CountryOption = {
  key: 'AU',
  name: 'Australia',
  type: 'country',
  country_code: 'AU',
  supports_region: true,
  supports_city: true,
};

export interface RegionOption {
  key: string;
  name: string;
  type: 'region';
  country_code: string;
  country_name: string;
  supports_region: boolean;
  supports_city: boolean;
}

export const exampleRegionOption: RegionOption = {
  key: '4059',
  name: 'Western Cape',
  type: 'region',
  country_code: 'ZA',
  country_name: 'South Africa',
  supports_region: true,
  supports_city: true,
};

export interface CityOption {
  key: string;
  name: string;
  type: 'city' | 'subcity' | 'neighborhood' | 'subneighborhood';
  country_code: string;
  country_name: string;
  region: string;
  region_id: number;
  supports_region: boolean;
  supports_city: boolean;
}

export const exampleCityOption: CityOption = {
  key: '2436503',
  name: 'Bloomington',
  type: 'city',
  country_code: 'US',
  country_name: 'United States',
  region: 'Idaho',
  region_id: 3855,
  supports_region: true,
  supports_city: true,
};

export interface ZipCodeOption {
  key: string;
  name: string;
  type: 'zip';
  country_code: string;
  country_name: string;
  region: string;
  region_id: number;
  primary_city: string;
  primary_city_id: number;
  supports_region: boolean;
  supports_city: boolean;
}

export const exampleZipCodeOption: ZipCodeOption = {
  key: 'US:61704',
  name: '61704',
  type: 'zip',
  country_code: 'US',
  country_name: 'United States',
  region: 'Illinois',
  region_id: 3856,
  primary_city: 'Bloomington',
  primary_city_id: 2437896,
  supports_region: true,
  supports_city: true,
};
